import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import {
    CreateDailyWasteBody,
    DailyWasteResponse,
    createDailyWaste,
    UpdateDailyWasteBody,
    updateDailyWaste,
    deleteDailyWaste,
} from '../../services/apiSLTP/dailyReports/dailyWastes';

type UseCreateDailyWasteMutationOptions = MutationOptions<DailyWasteResponse, Error, CreateDailyWasteBody>;
type UseUpdateDailyWasteMutationOptions = MutationOptions<DailyWasteResponse, Error, { dailyWasteId: string; data: UpdateDailyWasteBody }>;
type UseDeleteDailyWasteMutationOptions = MutationOptions<DailyWasteResponse, Error, string>;

export const useCreateDailyWasteMutation = (options?: UseCreateDailyWasteMutationOptions) => {
    const dailyWasteMutation: MutationFunction<DailyWasteResponse, CreateDailyWasteBody> = async (data) => {
        try {
            const response: DailyWasteResponse = await createDailyWaste(data);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during daily waste creation');
        }
    };

    return useMutation(dailyWasteMutation, options);
};

export const useUpdateDailyWasteMutation = (options?: UseUpdateDailyWasteMutationOptions) => {
    const dailyWasteMutation: MutationFunction<DailyWasteResponse, { dailyWasteId: string; data: UpdateDailyWasteBody }> = async ({
        dailyWasteId,
        data,
    }) => {
        try {
            const response: DailyWasteResponse = await updateDailyWaste(dailyWasteId, data);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during daily waste update');
        }
    };

    return useMutation(dailyWasteMutation, options);
};

export const useDeleteDailyWasteMutation = (options?: UseDeleteDailyWasteMutationOptions) => {
    const dailyWasteMutation: MutationFunction<DailyWasteResponse, string> = async (dailyWasteId) => {
        try {
            const response: DailyWasteResponse = await deleteDailyWaste(dailyWasteId);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during daily waste deletion');
        }
    };

    return useMutation(dailyWasteMutation, options);
};
